import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import FullComparisonDialog from '@/plans/ZOOM_MEETING/dialog/full-comparison-dialog';
import { planTypes } from '@/common/constants';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings';
import { logger } from '@/utils/log';

export default {
  computed: {
    fullComparisonDialogProps() {
      return {}
    }
  },
  methods: {
    async showFullComparisonDialog() {
      this.$tracking.buyInteraction('switch plans selected', getTrackingProductNameByPlanType(planTypes.ZONE_PRO_PLUS));
      await this.fullComparisonDialog.confirm(this.fullComparisonDialogProps).catch((error) => {
        logger.warn('show full comparison dialog error or closed the full comparison dialog, error: ', error);
      });
    },
  },
  created() {
    this.fullComparisonDialog = new ServiceConfirm(FullComparisonDialog);
  },
};
